import { render, staticRenderFns } from "./ProjectRoleInput.vue?vue&type=template&id=339ac558"
import script from "./ProjectRoleInput.vue?vue&type=script&lang=js"
export * from "./ProjectRoleInput.vue?vue&type=script&lang=js"
import style0 from "./ProjectRoleInput.vue?vue&type=style&index=0&id=339ac558&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports